export default "__VITE_ASSET__CqDvAaKF__"